<div class="register-page">
  <button
    *ngIf="openedAsModal"
    type="button"
    class="register-modal-close"
    aria-label="Close"
    (click)="modalRef?.close()"
  >
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </svg>
  </button>
  <div class="register-modal-brand" *ngIf="openedAsModal">
    <img
      src="/assets/img/gtn-logo-embed.svg"
      alt="GTN | EMBED"
      class="register-brand-img"
    />
  </div>
  <div class="register-layout container-fluid">
    <div class="row g-0 register-shell align-items-center">
      <div class="col-12 col-lg-12 register-form-panel">
        <div class="register-card-wrapper">
          <div class="register-card position-relative">
            <div *ngIf="registrationSuccess" class="register-success-state">
              <div class="alert alert-success" role="alert" data-mdb-color="success">
                <h4 class="alert-heading">
                  Thank you for registering for access to the GTN | Embed Developer Portal.
                </h4>
                <p>
                  We will be sending an e-mail to <b>{{ registeredEmail }}</b> containing a one-time password.
                  <br />
                </p>
                <hr />
                <p class="mb-0">
                  If you have not heard from us within 24 hours, please contact
                  <b>developer&#64;gtngroup.com</b> quoting request id: {{ requestId }}
                </p>
              </div>

              <div *ngIf="isBrokerSignup" class="mr-auto p-2">
                <a [href]="'/'" class="back-to-login-label" type="button">
                  <i class="custom-icon-button2" style="margin-right: 5px;"></i>
                </a>
                Already registered? <button (click)="login()">Sign In</button>
              </div>
            </div>

            <div *ngIf="!registrationSuccess">
              <div class="text-center mb-4">
                <h1 class="register-title" *ngIf="(role == 'admin' || role == 'brokerAdmin') && !isBrokerSignup">
                  User Registration Form
                </h1>
                <h1 class="register-title" *ngIf="isBrokerSignup">
                  Register Access to Developer Portal
                </h1>
              </div>

              <div class="row" *ngIf="role != 'brokerAdmin'">
                <form class="row g-3" [formGroup]="brokerForm" (ngSubmit)="onClickSubmitBroker()" novalidate>
                  <div class="col-md-12 text-start" *ngIf="!isBrokerSignup">
                    <div class="floating-field">
                      <select id="userRole" class="form-select" formControlName="userRole" (change)="getRole($event)"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['userRole'].errors }">
                        <option value="brokerAdmin">Admin User</option>
                        <option value="normalBroker">Normal User</option>
                        <option value="internalUser">Internal User</option>
                      </select>
                      <label for="userRole">Role</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['userRole'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['userRole'].errors['required']">Select a role</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="brokerFullName" formControlName="brokerFullName"
                        placeholder=" "
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerFullName'].errors }" />
                      <label for="brokerFullName">Full Name</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerFullName'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerFullName'].errors['required']">Full name is required</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start" *ngIf="formBrokerControl['userRole'].value !== 'internalUser'">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="brokerCompany" formControlName="brokerCompany"
                        placeholder=" "
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerCompany'].errors }" />
                      <label for="brokerCompany">Company Name</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerCompany'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerCompany'].errors['required']">Company name is required</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">

                      <ngx-intl-tel-input *ngIf="allowedCountryCodes.length > 0 || countryListFailed" class="form-control"
                        id="brokerContactNo" formControlName="brokerContactNo"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerContactNo'].errors }"
                        [cssClass]="'custom'" [enablePlaceholder]="true" [searchCountryFlag]="true"
                        [separateDialCode]="true" [maxLength]="15" [phoneValidation]="true"
                        [enableAutoCountrySelect]="true" [selectFirstCountry]="false"
                        [preferredCountries]="defaultCountryCodes"
                        [onlyCountries]="allowedCountryCodes"></ngx-intl-tel-input>
                      <label for="brokerContactNo" class="form-label">Phone Number</label>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <select class="form-select" id="countryCode" formControlName="brokerCountry"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerCountry'].errors }">
                        <option value="" disabled selected hidden></option>
                        <option *ngFor="let country of countries" [value]="country.countryId">
                          {{ country.countryName }}
                        </option>
                      </select>
                      <label for="countryCode">Country</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerCountry'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerCountry'].errors['required']">Select a country</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="brokerEmail" formControlName="brokerEmail"
                        placeholder=" " (change)="onEmailChange($event)"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerEmail'].errors }" />
                      <label for="brokerEmail">Business Email Address</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerEmail'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerEmail'].errors['required']">E-mail is required</div>
                      <div *ngIf="formBrokerControl['brokerEmail'].errors['alreadyExist']">E-mail already exists</div>
                      <div *ngIf="formBrokerControl['brokerEmail'].errors['invalid']">E-mail is not valid</div>
                      <div
                        *ngIf="formBrokerControl['userRole'].value == 'internalUser' && !formBrokerControl['brokerEmail'].value.endsWith('&#64;gtngroup.com')">
                        E-mail must end with &#64;gtngroup.com for Internal User role
                      </div>
                      <div *ngIf="formBrokerControl['brokerEmail'].errors['containsUpperCase']">
                        Uppercase characters are not allowed for E-mail
                      </div>
                    </div>
                    <small class="clarifier-text">
                      Please provide a current e-mail address: we will be sending your login details to this address and
                      it will be your username when logging in
                    </small>
                  </div>

                  <div *ngIf="isBrokerSignup" class="col-md-12 text-start">
                    <label for="recaptcha" class="form-label"></label>
                    <re-captcha [siteKey]="siteKey" formControlName="recaptcha" (resolved)="onCaptchaResolved($event)">
                    </re-captcha>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['recaptcha'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['recaptcha'].errors['required']">Captcha verification is required.
                      </div>
                    </div>
                  </div>

                  <hr class="hr-line" style="margin-bottom: 10px;" *ngIf="!isBrokerSignup" />

                  <div class="col-md-12 text-start" *ngIf="!isBrokerSignup">
                    <div class="floating-field">
                      <select id="region" class="form-select" formControlName="region"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['region'].errors }">
                        <option value="asia">ASIA</option>
                        <option value="mena">MENA</option>
                        <option value="global sandbox">GLOBAL SANDBOX</option>
                      </select>
                      <label for="region">Region</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['region'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['region'].errors['required']">Select a region</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start"
                    *ngIf="!isBrokerSignup && formBrokerControl['userRole'].value !== 'internalUser'">
                    <div class="floating-field">
                      <select id="institutionSelect" class="form-select" formControlName="brokerInstitution"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerInstitution'].errors }"
                        *ngIf="formBrokerControl['region'].value === 'asia' || formBrokerControl['region'].value === 'mena'">
                        <option [hidden]="formBrokerControl['region'].value === 'mena'"
                          [ngValue]="institution.institutionId" *ngFor="let institution of institutions">
                          {{ institution.institution }}
                        </option>

                        <option [hidden]="formBrokerControl['region'].value === 'asia'"
                          [ngValue]="institution.institutionId" *ngFor="let institution of institutionsDIFC">
                          {{ institution.institution }}
                        </option>

                        <option [hidden]="formBrokerControl['region'].value === 'global sandbox'"
                          [ngValue]="institution.institutionId" *ngFor="let institution of institutionsDIFC">
                          {{ institution.institution }}
                        </option>
                      </select>
                      <label for="institutionSelect">Institution</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerInstitution'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerInstitution'].errors['required']">Select a institution</div>
                    </div>
                  </div>

                  <h3 class="form-label optional-title" *ngIf="!isBrokerSignup">Optional</h3>
                  <hr *ngIf="!isBrokerSignup" />
                  <p class="form-label" *ngIf="!isBrokerSignup">
                    <i class="custom-icon-button1"></i>
                    You can define a password for respective broker account or you can leave it empty and GTN will
                    create
                    random password and share it with broker via email.
                  </p>

                  <div class="col-md-12 text-start" *ngIf="!isBrokerSignup">
                    <div class="floating-field">
                      <input type="password" class="form-control" id="brokerPassword" formControlName="brokerPassword"
                        placeholder=" " (change)="getPassword($event)"
                        [ngClass]="{ 'is-invalid': brokerUserSubmitted && formBrokerControl['brokerPassword'].errors }"
                        (focus)="onNewPasswordFocus()" (blur)="onNewPasswordBlur()" />
                      <label for="brokerPassword">Password</label>
                    </div>
                    <div *ngIf="brokerUserSubmitted && formBrokerControl['brokerPassword'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formBrokerControl['brokerPassword'].errors['invalid']">Invalid Password format</div>
                      <div *ngIf="formBrokerControl['brokerPassword'].errors['minlength']">Password must be at least 8
                        characters</div>
                    </div>
                    <app-password-strength-bar *ngIf="showPasswordStrength" barLabel="Password Strength"
                      [passwordToCheck]="brokerForm.controls['brokerPassword'].value"></app-password-strength-bar>
                  </div>

                  <div class="">
                    <div class="p-2">
                      <button class="btn btn-primary register-submit-btn mt-4 btn-lg" type="submit"
                        [disabled]="!validCaptcha">
                        <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <span *ngIf="!loading && !isBrokerSignup">Create</span>
                        <span *ngIf="!loading && isBrokerSignup">Submit</span>
                      </button>
                    </div>

                    <div *ngIf="isBrokerSignup" class="mr-auto p-2 text-center">

                      Already registered? <button (click)="login()" class="btn-signin">Sign In</button>
                      <br />
                      <a [href]="'/'" class="back-to-login-label" type="button">
                        Back to GTN Developer Portal
                      </a>
                    </div>
                  </div>
                </form>
              </div>

              <div class="row" *ngIf="role == 'brokerAdmin'">
                <form class="row g-3" [formGroup]="normalBrokerForm" (ngSubmit)="onClickSubmitNormalBroker()"
                  novalidate>
                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerFirstName"
                        formControlName="normalBrokerFirstName" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerFirstName'].errors }" />
                      <label for="normalBrokerFirstName">First name</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerFirstName'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerFirstName'].errors['required']">First name is
                        required</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerLastName"
                        formControlName="normalBrokerLastName" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerLastName'].errors }" />
                      <label for="normalBrokerLastName">Last name</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerLastName'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerLastName'].errors['required']">Last name is
                        required</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerCompany"
                        formControlName="normalBrokerCompany" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerCompany'].errors }" />
                      <label for="normalBrokerCompany">Company name</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerCompany'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerCompany'].errors['required']">Company name is
                        required</div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <label for="normalBrokerContactNo" class="form-label">Phone Number</label>
                    <ngx-intl-tel-input *ngIf="allowedCountryCodes.length > 0" class="form-control"
                      id="normalBrokerContactNo" formControlName="normalBrokerContactNo"
                      [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerContactNo'].errors }"
                      [cssClass]="'custom'" [enablePlaceholder]="true" [searchCountryFlag]="true"
                      [separateDialCode]="true" [customPlaceholder]="''" [maxLength]="15" [phoneValidation]="true"
                      [enableAutoCountrySelect]="true" [selectFirstCountry]="false"
                      [preferredCountries]="defaultCountryCodes"
                      [onlyCountries]="allowedCountryCodes"></ngx-intl-tel-input>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <select class="form-select" formControlName="normalBrokerCountry"
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerCountry'].errors }"
                        id="normalBrokerCountry">
                        <option value="" disabled selected hidden></option>
                        <option *ngFor="let country of countries" [value]="country.countryId">
                          {{ country.countryName }}
                        </option>
                      </select>
                      <label for="normalBrokerCountry">{{ defaultCountryName || 'Country' }}</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerCountry'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerCountry'].errors['required']">Select a country
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerEmail" formControlName="normalBrokerEmail"
                        placeholder=" " (change)="getemail($event)"
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerEmail'].errors }" />
                      <label for="normalBrokerEmail">E-mail</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerEmail'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerEmail'].errors['required']">E-mail is required
                      </div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerEmail'].errors['email']">E-mail is not valid
                      </div>
                    </div>
                  </div>

                  <hr class="hr-line" style="margin-bottom: 10px;" *ngIf="!isNormalBrokerSignup" />

                  <div class="col-md-12 text-start" *ngIf="!isNormalBrokerSignup">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerInstitution"
                        formControlName="normalBrokerInstitution" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerInstitution'].errors }"
                        [readonly]="true" [value]="defaultInstitution" />
                      <label for="normalBrokerInstitution">Institution</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerInstitution'].errors"
                      class="invalid-feedback d-block"></div>
                  </div>

                  <div class="col-md-12 text-start" *ngIf="!isNormalBrokerSignup">
                    <div class="floating-field">
                      <input type="text" class="form-control" id="normalBrokerRegion"
                        formControlName="normalBrokerRegion" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerRegion'].errors }"
                        [readonly]="true" [value]="defaultRegion" />
                      <label for="normalBrokerRegion">Region</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerRegion'].errors"
                      class="invalid-feedback d-block"></div>
                  </div>

                  <div class="col-6 mb-3 text-start" *ngIf="!isNormalBrokerSignup">
                    <h6>APIs</h6>
                    <p class="text-muted">{{ apis }}</p>
                  </div>

                  <h3 class="form-label optional-title" *ngIf="!isNormalBrokerSignup">Optional</h3>
                  <hr *ngIf="!isNormalBrokerSignup" />
                  <p class="form-label" *ngIf="!isNormalBrokerSignup">
                    <i class="custom-icon-button1"></i>
                    You can define a password for respective broker account or you can leave it empty and GTN will
                    create
                    random password and share it with broker via email.
                  </p>

                  <div class="col-md-12 text-start">
                    <div class="checkbox-username-div">
                      <div>
                        <label for="normalBrokerUserName" class="form-label">Username</label>
                      </div>
                    </div>
                    <div class="floating-field">
                      <input type="text" (ngModelChange)="$event && checkNormalBrokerUserName($event)"
                        [(ngModel)]="email1" class="form-control" id="normalBrokerUserName"
                        formControlName="normalBrokerUserName" placeholder=" "
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerUserName'].errors }" />
                      <label for="normalBrokerUserName">Username</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerUserName'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['required']">Username is
                        required</div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['alreadyExist']">Username
                        already exists</div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['invalid']">Username is invalid
                      </div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['containsUpperCase']">
                        Uppercase characters are not allowed for username
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start" *ngIf="!isNormalBrokerSignup">
                    <div class="checkbox-username-div">
                      <div>
                        <input type="checkbox" id="cb2" ng-model="check" (change)="checkBoxFunc($event)" />
                        (Same as email)
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 text-start" *ngIf="!isNormalBrokerSignup">
                    <div class="floating-field">
                      <input type="password" class="form-control" id="normalBrokerPassword"
                        formControlName="normalBrokerPassword" placeholder=" " (change)="getPassword($event)"
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerPassword'].errors }"
                        (focus)="onNewPasswordFocus()" (blur)="onNewPasswordBlur()" />
                      <label for="normalBrokerPassword">Password</label>
                    </div>
                    <div *ngIf="normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerPassword'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="formNormalBrokerControl['normalBrokerPassword'].errors['invalid']">Invalid Password
                        format</div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerPassword'].errors['minlength']">Password must be
                        at least 8 characters</div>
                    </div>
                    <app-password-strength-bar *ngIf="showPasswordStrength" barLabel="Password Strength"
                      [passwordToCheck]="normalBrokerForm.controls['normalBrokerPassword'].value"></app-password-strength-bar>
                  </div>

                  <div class="col-md-12 text-start" *ngIf="!isNormalBrokerSignup">
                    <div class="floating-field">
                      <input type="password" class="form-control" id="normalBrokerConfirmPassword"
                        formControlName="normalBrokerConfirmPassword" placeholder=" "
                        (ngModelChange)="$event && checkConfirmPassword($event)"
                        [ngClass]="{ 'is-invalid': normalBrokerUserSubmitted && formNormalBrokerControl['normalBrokerConfirmPassword'].errors && passwordEntered }" />
                      <label for="normalBrokerConfirmPassword">Confirm Password</label>
                    </div>
                    <div
                      *ngIf="normalBrokerUserSubmitted && passwordEntered && formNormalBrokerControl['normalBrokerConfirmPassword'].errors"
                      class="invalid-feedback d-block">
                      <div *ngIf="passwordEntered && !passwordNotNull">Password is required</div>
                      <div
                        *ngIf="formNormalBrokerControl['normalBrokerConfirmPassword'].errors['matching'] && passwordNotNull">
                        Password is not matching
                      </div>
                      <div *ngIf="formNormalBrokerControl['normalBrokerConfirmPassword'].errors['invalid']">Password is
                        invalid</div>
                    </div>
                  </div>

                  <div class="d-flex flex-row-reverse align-items-baseline">
                    <div class="p-2">
                      <button class="btn btn-primary register-submit-btn mt-4" type="submit">
                        <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <span *ngIf="!loading">Create</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div *ngIf="initialLoading" class="position-absolute top-50 start-50 translate-middle">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>